<template>
  <div>
    <b-sidebar
      id="sidebar-filter"
      v-model="showSlide"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      aria-labelledby="sidebar-filter-title"
      @hidden="hide()"
      no-header
    >
      <template>
        <div>
          <div class="p-2 d-flex justify-content-between align-items-center">
            <label class="header-text">กรองข้อมูล</label>
            <label class="pointer" @click="hide"
              ><b-icon icon="x-circle-fill"></b-icon
            ></label>
          </div>
          <div>
            <div class="p-2">
              <InputText
                textFloat="หมายเลขสมาชิก (Member ID)"
                v-model="filter.memberId"
                class="mb-2"
                placeholder="Member ID"
                type="text"
              />
              <InputText
                textFloat="ชื่อสมาชิก (Member Name)"
                v-model="filter.member_name"
                class="mb-2"
                placeholder="Name"
                type="text"
              />
              <InputText
                textFloat="หมายเลขโทรศัพท์ (Phone No.)"
                v-model="filter.telephone"
                class="mb-2"
                placeholder="Phone No."
                type="text"
              />
              <InputText
                textFloat="หมายเลขใบเสร็จ (POS Ref No.)"
                v-model="filter.ticket_no"
                class="mb-2"
                placeholder="POS Ref No."
                type="text"
              />
              <div class="mb-2">
                <div class="header-text">วันที่เริ่มต้น</div>
                <div :class="['input-container']">
                  <datetime
                    :input-style="styleDatetime"
                    v-model="filter.start_datetime"
                    placeholder="DD/MM/YYYY"
                    @close="changeStartDate"
                    ref="startDate"
                  >
                  </datetime>
                  <div
                    class="icon-container text-right"
                    @click="$refs.startDate.isOpen = true"
                  >
                    <font-awesome-icon icon="calendar-alt" class="text-main" />
                  </div>
                </div>
              </div>
              <div class="mb-2">
                <div class="header-text">วันที่สิ้นสุด</div>
                <div :class="['input-container']">
                  <datetime
                    :input-style="styleDatetime"
                    v-model="filter.end_datetime"
                    placeholder="DD/MM/YYYY"
                    :min-datetime="filter.start_datetime"
                    @close="onChangeEndDate"
                    ref="endDate"
                  >
                  </datetime>
                  <div
                    class="icon-container text-right"
                    @click="$refs.endDate.isOpen = true"
                  >
                    <font-awesome-icon icon="calendar-alt" class="text-main" />
                  </div>
                </div>
              </div>
              <!-- <InputText
                textFloat="รหัสพนักงาน (Saleperson ID)"
                v-model="filter.sales_no"
                class="mb-2"
                placeholder="Saleperson ID"
                type="text"
              /> -->
              <!-- <div>
                <div class="header-text">สาขา</div>
                <b-form-select
                  class="input-container"
                  v-model="filter.branch_id"
                  :options="branchOption"
                  text-field="name"
                  value-field="id"
                ></b-form-select>
              </div> -->
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="text-center p-2">
          <p @click="clearFilter"><u>ล้างตัวกรอง</u></p>
          <b-button class="radius-btn bg-main mt-2" block @click="submitForm"
            ><span>ค้นหา</span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
export default {
  name: "SlideFilter",
  components: { InputText },
  props: {
    filter: {
      type: Object,
      isRequired: true,
    },
    branchOption: {
      type: Array,
      isRequired: false,
    },
  },
  data() {
    return {
      showSlide: false,
      styleDatetime: {
        width: "100%",
        border: "none",
      },
    };
  },
  methods: {
    show() {
      this.showSlide = true;
    },
    hide() {
      this.showSlide = false;
    },
    changeStartDate() {
      if (!this.filter.end_datetime) {
        this.filter.end_datetime = this.filter.start_datetime;
      }
      if (this.filter.start_datetime >= this.filter.end_datetime) {
        this.filter.end_datetime = this.$moment(this.filter.start_datetime)
          .add("day", 0)
          .format();
      }
    },
    onChangeEndDate() {
      if (!this.filter.start_datetime) {
        this.filter.start_datetime = this.filter.end_datetime;
      }
    },
    async clearFilter() {
      this.filter.search = "";
      this.filter.page = 1;
      this.filter.take = 8;

      this.filter.memberId = "";
      this.filter.member_name = "";
      this.filter.telephone = "";
      this.filter.ticket_no = "";
      this.filter.start_datetime = "";
      this.filter.end_datetime = "";
      // this.filter.sales_no = "";
      this.filter.branch_id = 0;
      
      this.$emit("onSubmitFilter");
    },
    async submitForm() {
      await this.$emit("onSubmitFilter");
      this.hide();
    },
  },
};
</script>

<style scoped>
.input-container {
  display: flex;
  height: 100%;
  padding: 0.5rem;
  background-color: white;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
}
</style>
